// extracted by mini-css-extract-plugin
export default {"image":"single-cube_pieces_occasion-banner_image"};